import React from 'react';
import {LicenseStatus} from "../models/license.models";
import LoadingSpinner from "../components/common/LoadingSpinner";
import {Navigate, Outlet} from "react-router-dom";
import {RoutePaths} from "../config/routeConstants";
import {useLicenseValidation} from "../contexts/LicenseProvider";

const LicenseActivationGuard = () => {
    const {status} = useLicenseValidation();

    if (status === LicenseStatus.CHECKING) {
        return <LoadingSpinner/>;
    }

    if (status === LicenseStatus.VALID) {
        return <Navigate to={RoutePaths.Dashboard} replace />;
    }

    return <Outlet />;
};

export default LicenseActivationGuard;